import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';

import { FuseSidebarService } from '../../../@fuse/components/sidebar/sidebar.service';

export const CREATE_CLIENT_PANEL_NAME = 'createClientPanel';

export interface CreateClientPanelData {
  navigateToClient?: boolean;
  type?: string;
  uuid?: string;
}

@Injectable({ providedIn: 'root' })
export class CreateClientPanelService {
  private _result$: Subject<any | false> | null = null;
  private readonly _isOpen$ = new BehaviorSubject<boolean>(false);
  private _data: CreateClientPanelData | null = null;

  readonly isOpen$ = this._isOpen$.asObservable();

  constructor(private _fuseSidebarService: FuseSidebarService) {}

  open(data?: CreateClientPanelData): Observable<any | false> {
    if (this._result$) {
      this._result$.complete();
    }
    this._result$ = new Subject<any | false>();
    this._data = data ?? null;

    this._isOpen$.next(true);
    setTimeout(() => {
      const sidebar = this._fuseSidebarService.getSidebar(
        CREATE_CLIENT_PANEL_NAME,
      );
      sidebar?.open();
    });

    return this._result$.asObservable().pipe(take(1));
  }

  getData(): CreateClientPanelData | null {
    return this._data;
  }

  emitResult(result: any | false): void {
    const sidebar = this._fuseSidebarService.getSidebar(
      CREATE_CLIENT_PANEL_NAME,
    );
    sidebar?.close();

    this._result$?.next(result);
    this._result$?.complete();
    this._result$ = null;
    this._data = null;
    this._isOpen$.next(false);
  }
}
